import { useQuery } from '@tanstack/react-query';
import { api } from '../client';

export interface TrendPoint {
  date: string;
  value: number | null;
  protocol: string | null;
  markers?: Array<{ key: string; name: string; value: number; unit: string; category: string }>;
}

export function useTrends(biomarker?: string | null) {
  return useQuery<{ trends: TrendPoint[] }>({
    queryKey: ['mr-trends', biomarker],
    queryFn: () =>
      api.get<{ trends: TrendPoint[] }>(
        `/bloodwork/trends${biomarker ? `?biomarker=${biomarker}` : ''}`,
      ),
  });
}
